import type { Language } from '@seek/melways-sites';

import JobApplication, { type IJobApplication } from '../JobApplication';
import { mapApplicationResponseToStore } from './mapApiResponseToStore';
import { fetchApplicationByAdcentreProspectId } from 'src/graphql/fetchApplicationByAdcentreProspectId.hirer.graphql';
import { logError } from 'src/utils/logError';
import { LocationDisplayFormat } from 'src/App/AppPageBlock/graphql/hirer-types.generated';

export const getDetailedJobApplicationFromHirerGraph = async (
  adcentreProspectId: string,
  jobId: number,
  language: Language,
  displayCountry: string,
): Promise<IJobApplication | 'UNAUTHENTICATED'> => {
  try {
    const application = await fetchApplicationByAdcentreProspectId({
      input: {
        jobId,
        adcentreProspectId,
      },
      nationalitiesInput2: { jobId },
      displayLabelInput2: { language },
      countryNameInput2: { language },
      displayDescriptionInput2: {
        language,
        displayFormat: LocationDisplayFormat.SHORT,
        displayCountry,
      },
    });

    return JobApplication.create({
      ...mapApplicationResponseToStore(application.result),
    });
  } catch (error: any) {
    logError(
      {
        errorCode: 'GET_JOB_APPLICATION_BY_PROSPECT_ID',
        description:
          'Error attempting: getDetailedJobApplicationFromHirerGraph',
      },
      { error },
    );

    if (error.message === 'UNAUTHENTICATED') {
      return 'UNAUTHENTICATED';
    }
    throw error;
  }
};
